export const DEMO_ORGANIZATION_IDS: number[] = (import.meta.env.VITE_DEMO_ORGANIZATION_IDS ?? '')
  .split(',')
  .map(Number)
  .filter(Boolean);

export function isDemoOrganization(organizationId: number | undefined | null): boolean {
  if (!organizationId) return false;
  return DEMO_ORGANIZATION_IDS.includes(organizationId);
}
